import { Box, Theme, Typography } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { searchPath } from "@outschool/routes";
import { TrackedButton } from "@outschool/ui-components-shared";
import {
  ListingCarousel,
  ListingCarouselProps
} from "@outschool/ui-components-website";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";

export const ActivitiesCarousel = React.forwardRef(
  (
    {
      trackingName,
      showFindMoreButton = true,
      findMoreRedirectUrl = searchPath(),
      ...props
    }: ListingCarouselProps & {
      overrideShowCredits?: boolean;
      trackingName: string;
      showFindMoreButton?: boolean;
      findMoreRedirectUrl?: string;
    },
    ref: React.Ref<any>
  ) => {
    const { t } = useTranslation("client\\components\\NewUserHome");
    const navigation = useNavigation();
    const scrollTimer = () => {
      let slideTimer: NodeJS.Timeout | null = null;
      return (
        element: HTMLElement,
        _distance: number | null,
        direction: "left" | "right"
      ) => {
        const slideDist = 283;
        let scrollStepAmount = 10;
        let scrollAmount = 0;
        if (slideTimer) {
          clearInterval(slideTimer);
        }
        slideTimer = setInterval(function () {
          if (
            slideDist !== null &&
            scrollAmount + scrollStepAmount >= slideDist
          ) {
            clearInterval(slideTimer!);
            slideTimer = null;
            scrollStepAmount = slideDist - scrollAmount;
          }
          if (direction === "left") {
            element.scrollLeft -= scrollStepAmount;
          } else {
            element.scrollLeft += scrollStepAmount;
          }
          scrollAmount += scrollStepAmount;
        }, 7);
      };
    };

    return (
      <Box
        ref={ref}
        sx={(theme: Theme) => ({
          marginTop: "6.8rem",
          [theme.breakpoints.down("sm")]: {
            marginTop: "0rem",
            paddingLeft: "2rem"
          }
        })}
      >
        <Typography variant="display2" sx={{ textAlign: "center" }}>
          {props.title}
        </Typography>
        <Box
          sx={(theme: Theme) => ({
            maxWidth: "1150px",
            marginX: "auto",
            [theme.breakpoints.down("sm")]: {
              marginY: "3rem"
            }
          })}
        >
          <ListingCarousel
            {...props}
            title={undefined}
            arrowSx={{
              backgroundColor: "transparent",
              top: "-120px"
            }}
            innerContainerSx={{
              paddingY: "0"
            }}
            rightArrowSx={{
              right: "-30px"
            }}
            leftArrowSx={{
              left: "-30px"
            }}
            columnWidth={265}
            customScrollTimer={scrollTimer()}
          />
        </Box>
        {showFindMoreButton && (
          <Box
            sx={(theme: Theme) => ({
              display: "flex",
              justifyContent: "center",
              paddingBottom: "10.3rem",
              [theme.breakpoints.down("md")]: {
                paddingBottom: "5rem"
              }
            })}
          >
            <TrackedButton
              variant="contained"
              trackingName={trackingName}
              onClick={() => navigation(findMoreRedirectUrl, { hardNav: true })}
            >
              <Trans t={t}>Find More Classes</Trans>
            </TrackedButton>
          </Box>
        )}
      </Box>
    );
  }
);
